// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3431":"975e90c0","3982":"7ce09918","6494":"8f479842","6694":"6c61db8d"}[chunkId] + ".chunk.css";
};